module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-type-preface element-with-heading",
    attrs: {
      "id": "preface"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "preface-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Preface")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "preface-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('i', [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('span', {
    staticClass: "first-punctuation"
  }, [_vm._v("‘")]), _vm._v("I")]), _vm._v("t is")]), _vm._v(" a coroner’s statutory duty to hold inquests when there is reasonable cause to suspect a violent or unnatural death; but a coroner cannot act unless he is "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("informed")]), _vm._v(".’")])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-right"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_c('sup', [_vm._v("John Troutbeck, Westminster "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("and")])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_c('sup', [_vm._v("South-Western London "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("Coroner")])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_c('sup', [_vm._v("(letter to ")]), _c('i', [_c('sup', [_vm._v("The Times")])]), _c('sup', [_vm._v(" June 10th "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("1908")]), _vm._v(")")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4559a71a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preface.vue
// module id = 78
// module chunks = 0